import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importa i file di traduzione
import translationIT from './translations/it.json';
import translationEN from './translations/en.json';

const resources = {
  it: {
    translation: translationIT
  },
  en: {
    translation: translationEN
  }
};


i18n
  // Rileva la lingua del browser
  .use(LanguageDetector)
  // Passa l'istanza i18n a react-i18next
  .use(initReactI18next)
  // Inizializza i18next
  .init({
    resources,
    fallbackLng: 'it', // Lingua di fallback (italiano)
    debug: process.env.NODE_ENV === 'development',
    returnObjects: true, // Permette l'accesso agli oggetti nelle traduzioni
    interpolation: {
      escapeValue: false // React lo fa già
    }
  });

export default i18n;